import { createFeatureSelector } from '@ngrx/store';

export const freeProductsImagesState = createFeatureSelector<OLO.State, OLO.State.FreeProductImage[]>('freeProductsImages');
